// The output gate for Share / copy-result / send, in one place (owner decisions 29 Oct 2026). Sharing or copying a
// tool's RESULT is a way the result leaves the page, exactly like a download, on EVERY tool that has a trial gate
// (Premium Applications 2/day pool, Professional Tools 10/day pool):
//   - checkExport() runs first and takes no use; at 0 remaining it has already opened the paywall and NOTHING is
//     shared;
//   - the visit's one use is taken only after the share really happened (a cancelled share sheet or a failed copy
//     costs nothing).
// Not gated: sharing the site itself (a "share FreeDailyPro" link), copying non-result UI, viewing or previewing.

export interface ShareGateDeps {
  toolId: string;
  /** False when the page is not a counted tool (unknown id) or the visitor is on a paid pass. */
  counted: boolean;
  /** lib/exportGate checkExport: true when allowed; false when the paywall is already open. */
  checkExport: () => Promise<boolean>;
  /** Takes the visit's one use (no-op when this visit already counted). */
  charge: () => Promise<unknown>;
}

/**
 * Runs `doShare` through the gate. `doShare` returns false when nothing was shared (unsupported, copy failed) and
 * may throw (AbortError from a cancelled share sheet): either way no use is taken. Resolves true when shared.
 */
export async function runGatedShare(deps: ShareGateDeps, doShare: () => Promise<boolean | void>): Promise<boolean> {
  if (!deps.counted) return (await doShare()) !== false;
  if (!(await deps.checkExport())) return false;
  const shared = (await doShare()) !== false;
  if (shared) await deps.charge();
  return shared;
}
